import markdown from '@wcj/markdown-to-html';

/**
 * this closure does specific work for the
 * results section of the subject finder app
 */
const _aiResults = (function () {
    function AI({ storage, dsIntegration, helpers, globals, snapshot }) {
        let aiResultsList = [];
        let aiResultsTitles = [];
        let halfResults = [];
        let requesting = false;

        const self = this;
        const globalProps = globals;
        const resultLoader = document.querySelector(
            `[data-role="result-loader"]`
        );
        const resultsTitle = document.querySelector(
            `[data-role="results-page-title"]`
        );
        const resultControls = document.querySelector(
            `[data-role="result-controls"]`
        );
        const resultReloader = document.querySelector(
            `[data-role="result-reloader"]`
        );
        const furtherStudyCta = document.querySelector(
            `[data-cta="further-study-options"]`
        );
        const browseSubjectsCta = document.querySelector(
            `[data-cta="browse-subjects"]`
        );
        const resultsTagline = document.querySelector(
            `[data-role="results-page-tagline"]`
        );
        const subscriptionCardCta = document.querySelector(
            '.subscription-card--yellow'
        );

        /// ///////////////////////////////////////
        // private methods

        function aiResultsKeyVal() {
            aiResultsList.forEach((item) => {
                aiResultsTitles.push(item.courseName);
            });
        }

        /**
         * builds out the markup for each of the
         * AI generated results
         */
        function buildAISuggestions(data) {
            aiResultsKeyVal();

            const results = [];

            const aiData = data || null;
            let buildData = [];

            if (!halfResults.length && data) {
                const halfIndex = aiData.length * 0.5;

                // get the first half of results
                buildData = aiData.filter((result, i) => i + 1 <= halfIndex);

                // save the end half of results
                halfResults = aiData.filter((result, i) => i + 1 > halfIndex);
            } else {
                buildData = halfResults;
                halfResults = [];
            }

            if (aiData) aiResultsList.push(...aiData);

            buildData.forEach((course) => {
                const {
                    url,
                    careers,
                    description,
                    recommendedHighSchoolSubjects,
                    thumbnailUrl,
                    courseName,
                } = course;

                const careerItems = [];
                const subjectItems = [];

                careers.forEach((career) => {
                    careerItems.push(`
                        <div class="ai-result-card__item">${career}</div>
                    `);
                });

                if (
                    recommendedHighSchoolSubjects instanceof Array &&
                    recommendedHighSchoolSubjects.length
                ) {
                    recommendedHighSchoolSubjects.forEach((subject) => {
                        subjectItems.push(`
                            <div class="ai-result-card__item">${subject}</div>
                        `);
                    });
                }

                results.push(`
                    <article class="ai-result-card">
                        <a
                            class="ai-result-card__link"
                            href="${url}"
                            >

                            <div class="ai-result-card__content">
                                <div class="ai-result-card__block">
                                    <!--p>${courseName}</p-->
                                    <h2>${courseName}</h2>
                                </div>

                                <hr class="ai-result-card__hr" />

                                <div class="ai-result-card__block">
                                    <p>
                                        ${markdown(description)}
                                    </p>

                                    ${
                                        subjectItems.length
                                            ? `
                                        <div class="ai-result-card__block">
                                            <strong>Recommended Hich School Subjects</strong>
                                            <div class="ai-result-card__items">
                                                ${subjectItems.join('')}
                                            </div>
                                        </div>
                                        `
                                            : ''
                                    }

                                    ${
                                        careerItems.length
                                            ? `
                                        <div class="ai-result-card__block">
                                            <strong>Suggested careers</strong>
                                            <div class="ai-result-card__items">
                                                ${careerItems.join('')}
                                            </div>
                                        </div>
                                        `
                                            : ''
                                    }
                                </div>
                            </div>

                            ${
                                thumbnailUrl
                                    ? `
                                <div class="ai-result-card__thumbnail">
                                    <img src="${thumbnailUrl}" />
                                </div>
                                `
                                    : ''
                            }
                        </a>
                    </article>                    
                `);
            });

            document.querySelector(`[data-role="ai-result-list"]`).innerHTML +=
                results.join('');

            resultLoader.classList.remove('hidden');
            resultLoader.disabled = false;
        }

        /// ////////////////////////////////////////
        // -- public

        this.buildAiResults = function (data, fullReplace) {
            if (data.length) {
                furtherStudyCta.classList.remove('hidden');
                browseSubjectsCta.classList.add('hidden');

                if (fullReplace) {
                    halfResults = [];
                    document.querySelector(
                        `[data-role="ai-result-list"]`
                    ).innerHTML = '';
                }

                buildAISuggestions.bind(this)(data);
            } else {
                browseSubjectsCta.classList.remove('hidden');
            }
        };

        /**
         * checks that the user has
         * answered a minimum number of
         * questions to generate an AI response
         *
         * @param {array} questions
         * the questions that are fed to the
         * AI endpoint
         *
         * @return {boolean}
         */
        function validateQuestions(questions) {
            const answered = [];

            if (questions.length >= 3) {
                questions.forEach(({ answers }) => {
                    if (answers.length) {
                        answered.push(answers);
                    }
                });
            }

            if (answered.length >= 3) return true;

            return false;
        }

        this.sendSubscription = function () {
            const stored = storage.get();

            if (
                !stored.emailOptIn ||
                !stored.about.questions ||
                !stored.about.questions['about-details']['users-name']
            )
                return;

            const optIn = stored.emailOptIn;
            const subName =
                stored.about.questions['about-details']['users-name'];
            const subEmail =
                stored.about.questions['about-details']['users-email'];
            const subType =
                stored.about.questions['about-details'][
                    'previous-nz-schooling'
                ] === 'No'
                    ? 'International student'
                    : 'Domestic student';

            const userData = {
                email: subEmail,
                first_name: subName,
                type: subType,
            };

            fetch(
                'https://www.otago.ac.nz/_design/integration-points/subject-finder-subject-list/subscribe-user',
                {
                    method: 'POST',
                    mode: 'cors',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(userData),
                }
            )
                .then((res) => {
                    res.json();
                })
                .catch((err) => console.error(err));
        };

        /**
         * build out the local storage data in
         * a shape that the AI results expect
         *
         * @param {callable} callback
         * fires when the fetch has complete
         * of if it fails
         *
         * @param {bool} newResults
         *  this will prompt a new fetch request
         * if it's true (false by default) and
         * load up new suggestions
         *
         * @return {void}
         */
        this.buildAIPostBodyData = function (callback, newResults, hardReload) {
            if (this.activeData.name !== 'your-results') return;

            const savedData = storage.get();
            const dataKeys = Object.getOwnPropertyNames(savedData);
            const aiSuggestions = {
                questions: [],
            };

            // globals.storageSnapshot = encodeURIComponent(JSON.stringify(savedData));

            // storage.set(savedData);

            if (newResults && aiResultsList.length) {
                aiResultsList = [];
                aiResultsTitles = [];
            }

            // get all answered questions
            this.each(
                'pages',
                ({ section, name }) => {
                    const dataSection = savedData[section];

                    if (!dataSection) return;

                    if (!savedData[section].questions) return;

                    const questions = savedData[section].questions[name];

                    if (questions && questions.mainQuestion) {
                        aiSuggestions.questions.push({
                            question: questions.mainQuestion,
                            answers: [
                                ...Object.values(questions)
                                    .filter(
                                        (value) =>
                                            value !== questions.mainQuestion
                                    )
                                    .filter(Boolean),
                            ],
                        });
                    }
                },
                true
            );

            const resultsSummaryContainer = document.querySelector(
                `[data-role="result-summary"]`
            );
            const resultsContainer = document.querySelector(
                `[data-role="ai-result-list"]`
            );

            if (validateQuestions(aiSuggestions.questions)) {
                const aiSummary = { ...aiSuggestions, query: 'summarize' };

                resultLoader.classList.remove('hidden');
                resultsTagline.classList.remove('hidden');
                subscriptionCardCta.classList.remove('hidden');

                resultsTitle.innerHTML = 'Results';
                resultsSummaryContainer.innerHTML = ``;

                if (requesting) return;

                if (hardReload) {
                    halfResults = [];
                }

                if (newResults) {
                    if (
                        globals.storageSnapshot === snapshot.set(savedData) &&
                        !hardReload
                    )
                        return;

                    requesting = true;

                    // resultsSummaryContainer.innerHTML = '';
                    resultsContainer.innerHTML = '';

                    // loader for the results
                    helpers.advancedLoader(resultsContainer, {
                        name: 'result-content',
                        message: 'Please wait while we fetch your results...',
                    });

                    const aiResults = {
                        ...aiSuggestions,
                        query: 'findCourses',
                    };

                    fetch(
                        'https://www.otago.ac.nz/_design/integration-points/subject-finder-subject-list/result-suggestions',
                        {
                            method: 'POST',
                            body: JSON.stringify(aiResults),
                        }
                    )
                        .then((res) => res.json())
                        .then((json) => {
                            if (json && json.courses.length) {
                                halfResults = [];
                                buildAISuggestions.bind(this)(json.courses);

                                resultReloader.classList.add('hidden');
                                browseSubjectsCta.classList.add('hidden');
                                resultLoader.classList.remove('hidden');

                                savedData.results = [...json.courses];
                                storage.set(savedData);

                                globalProps.storageSnapshot =
                                    snapshot.set(savedData);

                                furtherStudyCta.classList.remove('hidden');

                                // self.sendSubscription();
                            }

                            helpers.advancedLoader(null, {
                                name: 'result-content',
                            });

                            if (
                                json.keywords.length &&
                                (window.userUid || savedData.userUid)
                            ) {
                                savedData.results_keywords = [...json.keywords];
                                storage.set(savedData);

                                dsIntegration.updateUserData.bind(this)({
                                    results_keywords: encodeURIComponent(
                                        JSON.stringify(json.keywords)
                                    ),
                                });

                                requesting = false;

                                return;
                            }

                            dsIntegration.updateUserData.bind(this)(null);

                            requesting = false;

                            if (callback) callback();
                        })
                        .catch((err) => {
                            helpers.advancedLoader(null, {
                                name: 'result-content',
                            });

                            resultReloader.classList.remove('hidden');
                            resultLoader.classList.add('hidden');

                            furtherStudyCta.classList.add('hidden');
                            browseSubjectsCta.classList.remove('hidden');

                            resultsTitle.innerHTML =
                                'Unable to retrieve your results';
                            resultsSummaryContainer.innerHTML = `
                                <p>We're having trouble fetching results right now.</p>

                                <p>Please try reloading your results.</p>
                            `;

                            if (callback) callback();

                            requesting = false;

                            throw new Error(err);
                        });
                } else {
                    buildAISuggestions.bind(this)();
                }
            } else {
                resultLoader.classList.add('hidden');
                furtherStudyCta.classList.add('hidden');
                resultsTagline.classList.add('hidden');
                subscriptionCardCta.classList.add('hidden');
                browseSubjectsCta.classList.remove('hidden');

                resultsTitle.innerHTML =
                    'Enhance your results with more answers';
                resultsSummaryContainer.innerHTML = `
                    <p>The more information you provide, the better we can tailor your recommendations to you.</p>

                    <p>So that we can provide meaningful results, please <strong>answer a minimum of 3 questions.</strong></p>

                    <p>Please restart to add more information about yourself (existing information will be retained).</p>
                `;
            }
        };
    }

    return (props) => {
        return new AI(props);
    };
})();

export default _aiResults;
